var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-bg",
    d: "M0 0H30C32.2091 0 34 1.79086 34 4V30C34 32.2091 32.2091 34 30 34H0V0Z",
    fill: "#F9F8F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path-stroke",
    d: "M25.25 16.9987L14.25 16.9987M25.25 11.4987L14.25 11.4987M25.25 22.4987L14.25 22.4987M10.5833 16.9987C10.5833 17.505 10.1729 17.9154 9.66667 17.9154C9.16041 17.9154 8.75 17.505 8.75 16.9987C8.75 16.4924 9.16041 16.082 9.66667 16.082C10.1729 16.082 10.5833 16.4924 10.5833 16.9987ZM10.5833 11.4987C10.5833 12.005 10.1729 12.4154 9.66667 12.4154C9.16041 12.4154 8.75 12.005 8.75 11.4987C8.75 10.9924 9.16041 10.582 9.66667 10.582C10.1729 10.582 10.5833 10.9924 10.5833 11.4987ZM10.5833 22.4987C10.5833 23.005 10.1729 23.4154 9.66667 23.4154C9.16041 23.4154 8.75 23.005 8.75 22.4987C8.75 21.9924 9.16041 21.582 9.66667 21.582C10.1729 21.582 10.5833 21.9924 10.5833 22.4987Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/List-view.d4e9c1309aeaf89147ce2373973e4129.svg";
export { ForwardRef as ReactComponent };